import { render, staticRenderFns } from "./QrCodePage.vue?vue&type=template&id=96f71940&scoped=true"
import script from "./QrCodePage.vue?vue&type=script&lang=ts"
export * from "./QrCodePage.vue?vue&type=script&lang=ts"
import style0 from "./QrCodePage.vue?vue&type=style&index=0&id=96f71940&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f71940",
  null
  
)

export default component.exports